const DEFAULT_REDIRECT = (url) => {
    if (typeof window !== 'undefined') {
        window.location.assign(url);
    }
};
function defaults() {
    return {
        authRefreshPath: '/auth/refresh',
        meEndpoint: '/v1/me',
        loginPath: '/auth/login',
        logoutPath: '/auth/logout',
        redirect: DEFAULT_REDIRECT,
    };
}
let current = defaults();
/**
 * Override one or more configuration fields. Idempotent — most recent call
 * wins. Call before `bootstrap()` (typically in the shell's pre-render code).
 */
export function configure(config = {}) {
    current = {
        authRefreshPath: config.authRefreshPath ?? current.authRefreshPath,
        meEndpoint: config.meEndpoint ?? current.meEndpoint,
        loginPath: config.loginPath ?? current.loginPath,
        logoutPath: config.logoutPath ?? current.logoutPath,
        redirect: config.redirect ?? current.redirect,
    };
}
/** @internal */
export function getConfig() {
    return current;
}
/** @internal — for tests. */
export function _resetConfig() {
    current = defaults();
}
//# sourceMappingURL=config.js.map